/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dispatch, SetStateAction, useState } from "react";
import { Box, IconButton, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import IosSwitchMain from "../../components/iosSwitchMain";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router-dom";
import AddTagGroup from "../../Modals/addTagGroup";
import {
  useChangeTagGroupStatusMutation,
  useLazyDeleteTagGroupQuery,
} from "../../service/group&tags";
import { showError, showToast } from "../../constants/toasts";
import { ConfirmationModal } from "../../Modals/confirmationModal";

interface GroupRow {
  id: string;
  name: string;
  tags: string[];
  createAt: string;
  updateAt: string | null;
  isActive: boolean;
}

const GroupList = ({
  data,
  selectedGroup,
  setSelectedGroup,
  selectedGroupId,
  setSelectedGroupId,
  getGroupApi,
}: {
  data: GroupRow[];
  selectedGroup: GroupRow | null;
  setSelectedGroup: Dispatch<SetStateAction<GroupRow | null>>;
  selectedGroupId: string;
  setSelectedGroupId: Dispatch<SetStateAction<string>>;
  getGroupApi: () => void;
}) => {
  const [tagGroupStatus] = useChangeTagGroupStatusMutation();
  const [deleteTagGroup] = useLazyDeleteTagGroupQuery();
  const navigate = useNavigate();
  const [openDelete, setOpenDelete] = useState(false);
  let hidden = ["fullName"];

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const deleteGroupApi = async () => {
    try {
      const response = await deleteTagGroup({ id: selectedGroupId }).unwrap();
      if (response.status === 200) {
        getGroupApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const changeGroupStatusApi = async (id: string) => {
    try {
      const response = await tagGroupStatus({ id }).unwrap();
      if (response.status === 200) {
        getGroupApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const columns: GridColDef[] = [
    {
      flex: 2,
      minWidth: 50,
      field: "id",
      headerName: "S.No",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const allRowIds = params.api.getAllRowIds();
        const index = allRowIds.indexOf(params.id);
        return (
          <div className="user_block">
            <p>{index + 1}</p>
          </div>
        );
      },
    },

    {
      field: "name",
      headerName: "Group Name",
      flex: 2,
      minWidth: 150,
      sortable: false,
      editable: false,
      renderCell: (params: GridRenderCellParams<GroupRow>) => (
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          className="cursor_p"
          onClick={() => {
            navigate(`/manage-groups/tags/${params?.row?.id}`);
          }}
        >
          <span>{params?.row?.name}</span>
          <OpenInNewIcon fontSize="small" />
        </Box>
      ),
    },

    {
      flex: 2,
      minWidth: 150,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <IosSwitchMain
            checked={row?.isActive}
            onChange={() => changeGroupStatusApi(row?.id)}
          />
        );
      },
    },

    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedGroup(row);
                  setSelectedGroupId(row?.id);
                  setOpen(true);
                }}
              >
                <img src="/static/images/edit_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedGroupId(row?.id);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={data}
        />
      </div>

      <AddTagGroup
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        selectedGroup={selectedGroup}
        selectedGroupId={selectedGroupId}
        getGroupApi={getGroupApi}
      />

      <ConfirmationModal
        text={"Are you sure to delete this Group?"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={deleteGroupApi}
      />
    </>
  );
};

export default GroupList;
